(function (define) {
	'use strict';

	define(function (require) {

		var interceptor;

		interceptor = require('rest/interceptor');

		/**
		 * Authenticates the request using JWT Authentication
		 *
		 * @param {Client} [client] client to wrap
		 * @param {Object} config
		 *
		 * @returns {Client}
		 */
		return interceptor({
			request: function (request, config) {
				var token, headers;

				token = localStorage.getItem('x-socket-id');
				headers = request.headers || (request.headers = {});

				if ( token !== null && token !== 'undefined') {
					headers['X-Socket-ID'] = token;
				}

		    	return request;
			},
			response: function (response) {
				return response;
			}
		});

	});

}(
	typeof define === 'function' && define.amd ? define : function (factory) { module.exports = factory(require); }
	// Boilerplate for AMD and Node
));